<template>
    <div>
        <tech-resume-header page-name="履歴書一覧"></tech-resume-header>
        <div v-if="getTechResume.data">
            <div v-if="getTechResume.data.resume.length">
                <tech-resume-input></tech-resume-input>
                <tech-resume-list v-show="show"></tech-resume-list>
            </div>
            <!-- 0件メッセージ -->
            <not-found-msg v-else></not-found-msg>
        </div>

        <!-- メニュー -->
        <tech-menu ref="techResumeMenu"></tech-menu>
        <!-- メッセージ -->
        <info-msg ref="msg" :lev="lev" :msg="msg"></info-msg>

    </div>
</template>

<script>
    import NotFoundMsg from 'pages/commons/notFoundMsg/NotFoundMsg'
    import TechResumeHeader from 'pages/commons/header/Header'
    import TechResumeInput from './components/Input'
    import TechResumeList from './components/List'

    import TechMenu from './components/Menu'
    import InfoMsg from 'pages/commons/modal/infoMsg/InfoMsg'

    import {mapGetters} from 'vuex'

    export default {
        components: {
            TechResumeHeader,
            TechResumeInput,
            TechResumeList,
            NotFoundMsg,
            TechMenu,
            InfoMsg
        },
        data () {
            return {
                show: true,
                lev: 0,
                msg: "",
            }
        },
        created () {
            this.loadTechResume()
            this.resetRefresh('techResume')
        },
        activated () {
            if (this.getRefreshArr['techResume']) {
                this.loadTechResume()
            }
            this.resetRefresh('techResume')
        },
        watch: {
            getTechResumeLoadStatus (status) {
                if (status == 1) {
                    this.$store.dispatch('startProgress')
                }
                if (status == 2) {
                    this.$store.dispatch('doneProgress')
                }
                if (status == 3) {
                    this.$store.dispatch('doneProgress')
                }
            },
            getChangeTechResumeMailFlgStatus (status) {
                if (status == 1) {
                    this.$store.dispatch('startSpinner')
                }
                if (status == 2) {
                    this.$store.dispatch('doneSpinner')
                    let te = this.getChangeTechResumeMailFlg.tech 
                    if (te) {
                        this.openMsg(te.name + 'の送信Flg更新しました。')
                    } else {
                        this.openMsg('対象要員は存在しません。(削除済み)', 1)
                    }
                }
                if (status == 3) {
                    this.$store.dispatch('doneSpinner')
                }
            },
            getUpdateTechResumeRecentInDayStatus (status) {
                if (status == 1) {
                    this.$store.dispatch('startSpinner')
                }
                if (status == 2) {
                    this.$store.dispatch('doneSpinner')
                    let te = this.getUpdateTechResumeRecentInDay.tech 
                    if (te) {
                        this.openMsg(te.name + 'の受信日を更新しました。')
                    } else {
                        this.openMsg('対象要員は存在しません。(削除済み)', 1)
                    }
                }
                if (status == 3) {
                    this.$store.dispatch('doneSpinner')
                }
            },
            getSendMailComStatus (status) {
                if (status == 1) {
                    this.$store.dispatch('startSpinner')
                }
                if (status == 2) {
                    this.$store.dispatch('doneSpinner')
                    // 画面データ刷新
                    if (this.getSendMailComRes.sendId) {
                        this.$store.dispatch('changeTechResumeSpecifyOutTime', {
                            id: this.getSendMailComRes.sendId,
                            time: this.getSendMailComRes.sendIdTime 
                        })
                    } else {
                        this.loadTechResume()
                    }

                    // 結果メッセージ表示
                    this.openMsg(this.getSendMailComRes.sendCntMb + '人、' + this.getSendMailComRes.sendCnt + '件送信完了。')

                }
                if (status == 3) {
                    this.$store.dispatch('doneSpinner')
                }
            },
            getDeleteTechResumeStatus (statue) {
                if (status == 1) {
                    this.$store.dispatch('startSpinner')
                }
                if (status == 2) {
                    this.$store.dispatch('doneSpinner')
                }
                if (status == 3) {
                    this.$store.dispatch('doneSpinner')
                }
            }
        },
        computed: {
            ...mapGetters([
                  'getTechResumeLoadStatus'
                , 'getTechResume'
                , 'getRefreshArr'
                , 'getChangeTechResumeMailFlgStatus'
                , 'getChangeTechResumeMailFlg'
                , 'getUpdateTechResumeRecentInDayStatus'
                , 'getUpdateTechResumeRecentInDay'
                , 'getSendMailComStatus'
                , 'getSendMailComRes'
                , 'getDeleteTechResumeStatus'
            ])
        },
        methods: {
            resetRefresh (pageName) {
                this.$store.dispatch('resetRefreshArr', pageName)
            },
            loadTechResume () {
                this.$store.dispatch('loadTechResume', {
                    do: this.$route.params.do
                })
            },
            addResume () {
                this.$router.push({name:'TechResumeCreate', params:{
                    do: 'create'
                }})
            },
            openMsg (msg, lev=0) {
                this.msg = msg
                this.lev = lev
                this.$refs.msg.openThis()
            },
            showList () {
                this.show = true
            },
            hideList () {
                this.show = false
            },
        }
    }
</script>

<style lang="stylus" scoped>
</style>
